<!-- Sidenav -->
<block-ui>
<app-sidebar></app-sidebar>
<div class="main-content">
  <!-- Top navbar -->
  <app-navbar></app-navbar>
  <!-- Pages -->
  <div class="header bg-gradient-danger pb-8 pt-5 pt-md-1">

  </div>
  <router-outlet></router-outlet>
  <div class="container-fluid">
    <app-footer></app-footer>
  </div>
</div>
</block-ui>
